// extracted by mini-css-extract-plugin
module.exports = {"rotation":"SoluzioniDetailTemplate_rotation__10FwI"};